import type { ChatRoom } from 'models';
import { useState } from 'react';
import { Button, EntitySnippet, Flex, InformationLineIcon } from 'ui';
import { useChatUserInfo } from '../hooks';
import { ChatUserInfoModal } from './chat-user-info-modal';

type P = {
  chatroom: ChatRoom;
  onChatDeleted: () => Promise<void>;
};

const AVATAR_SIZE = 40;

const ChatUserHeader = ({ chatroom, onChatDeleted }: P) => {
  const { email, name, photo } = useChatUserInfo(chatroom);
  const [isInfoModalOpened, setIsInfoModalOpened] = useState(false);

  return (
    <>
      <Flex align="center" className="chat-header" justify="space-between">
        <EntitySnippet
          avatarProps={{
            photo,
            size: AVATAR_SIZE,
          }}
          descriptionProps={email ? { children: email } : undefined}
          titleProps={{
            children: name,
            ellipsis: { tooltip: name },
            weight: 'medium',
          }}
        />
        <Button
          icon={<InformationLineIcon />}
          onClick={() => {
            setIsInfoModalOpened(true);
          }}
          type="text"
        />
      </Flex>
      <ChatUserInfoModal
        chatroom={chatroom}
        isOpened={isInfoModalOpened}
        onChatDeleted={onChatDeleted}
        onClose={() => {
          setIsInfoModalOpened(false);
        }}
      />
    </>
  );
};

export default ChatUserHeader;
